module.exports = __webpack_public_path__ + "img/title.120cc630.png";